/**
 * Rótulo de página para o breadcrumb `Início › <Página>` da TopBar (Onda 0, item 5).
 * Nomes vindos do Figma quando a tela existe lá ("Minhas Reservas", "Pipeline Comercial",
 * "Pendências e Documentos"); para telas fora do Figma, o nome atual da página.
 *
 * Exportado para o A02 reutilizar na Sidebar/rotas — mesma regra do `utils/secoes.ts`:
 * prefixo mais específico primeiro (`/usuarios/saneamento-operador` casa antes de
 * `/usuarios`), e o casamento vale para subrotas (`/clientes/123/editar` → "Operações
 * e Clientes").
 */
export const ROTULOS_DE_ROTA: ReadonlyArray<readonly [prefixo: string, rotulo: string]> = [
  ['/usuarios/saneamento-operador', 'Saneamento OPERADOR'],
  ['/lgpd/meus-dados', 'Meus Dados'],
  ['/lgpd/incidente', 'Reportar Incidente'],
  ['/lgpd/ropa', 'Registro de Operações'],
  ['/agenda/pendentes', 'Agendamentos Pendentes'],
  ['/dashboard', 'Dashboard'],
  ['/reservas', 'Minhas Reservas'],
  ['/clientes', 'Operações e Clientes'],
  ['/operacoes', 'Operações e Clientes'],
  ['/pendencias-documentos', 'Pendências e Documentos'],
  ['/pendencias', 'Pendências e Documentos'],
  ['/documentos', 'Pendências e Documentos'],
  ['/renovacoes', 'Renovações'],
  ['/kanban', 'Pipeline Comercial'],
  ['/agenda', 'Agenda'],
  ['/estruturacao', 'Estruturação'],
  ['/oportunidades', 'Oportunidades'],
  ['/financeiro', 'Financeiro'],
  ['/notas-fiscais', 'Notas Fiscais'],
  ['/campanhas', 'Campanhas'],
  ['/equipes', 'Equipes'],
  ['/ranking', 'Ranking'],
  ['/niveis-consultor', 'Níveis'],
  ['/produtos/politicas-pendentes', 'Políticas pendentes'],
  ['/produtos', 'Produtos e Materiais'],
  ['/simulacao', 'Simulações'],
  ['/ia', 'Busca com IA'],
  ['/usuarios', 'Usuários'],
  ['/consultores', 'Consultores'],
  ['/candidaturas', 'Candidaturas'],
  ['/tenants', 'Empresas'],
  ['/auditoria', 'Auditoria'],
  ['/privacidade-lgpd', 'Privacidade (LGPD)'],
  ['/seguranca', 'Segurança'],
  ['/conteudo-primeiro-acesso', 'Conteúdo do Primeiro Acesso'],
  ['/primeiro-acesso', 'Primeiro Acesso'],
  ['/notificacoes', 'Notificações'],
  ['/perfil', 'Meu Perfil'],
  ['/configuracoes', 'Configurações'],
]

/**
 * Rótulo por persona (Onda 1 da Visão do Consultor), indexado pelo MESMO prefixo do mapa
 * acima. `null` = o consultor não tem essa tela (VC-08, 23/10: Operações e Clientes é só
 * do back-office — o breadcrumb não afirma um destino que o barra).
 * VC-09: as pendências/documentos do consultor são a "Central de Pendências".
 */
export const ROTULOS_DO_CONSULTOR: Readonly<Record<string, string | null>> = {
  '/clientes': null,
  '/operacoes': null,
  '/pendencias-documentos': 'Central de Pendências',
  '/pendencias': 'Central de Pendências',
  '/documentos': 'Central de Pendências',
}

/**
 * Rótulo da página para a rota atual, ou `null` quando a rota não tem nome mapeado.
 * `consultor` (critério `ehConsultor` de `menu.ts`) aplica `ROTULOS_DO_CONSULTOR`.
 */
export const rotuloDaRota = (pathname: string, consultor = false): string | null => {
  const hit = ROTULOS_DE_ROTA.find(
    ([prefixo]) => pathname === prefixo || pathname.startsWith(`${prefixo}/`)
  )
  if (!hit) return null
  if (consultor && hit[0] in ROTULOS_DO_CONSULTOR) return ROTULOS_DO_CONSULTOR[hit[0]]
  return hit[1]
}
